import { request } from '@/shared/api/request'

export const getBranches = (type) => request({ url: `admin/${type}/getBranches`, method: 'GET' })